import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import pluralize from 'pluralize';

import PriceMatrixHead from 'shared/components/price/PriceMatrixHead';
import PriceMatrixBody from 'shared/components/price/PriceMatrixBody';
import QuoteLoading from 'shared/components/price/QuoteLoading';
import { QUOTING } from 'shared/data/quoteSteps';

const PriceMatrix = (props) => {
  const {
    lineItem,
    tableStripe,
    tableSm,
    quoteStep,
    leadTimeText,
  } = props;

  const { lead_times, quantities } = lineItem;

  const className = classnames('table real-matrix', {
    'table-striped': tableStripe,
    'table-sm': tableSm,
  });

  if (quoteStep === QUOTING) return <QuoteLoading />;

  return (
    <div className="table-responsive price-matrix">
      <table className={className}>
        <PriceMatrixHead leadTimes={lead_times} leadTimeText={leadTimeText} />
        <PriceMatrixBody
          quantities={quantities}
          leadTimes={lead_times}
          {...props} />
      </table>
    </div>
  );
};

PriceMatrix.defaultProps = {
  tableStripe: true,
  tableSm: false,
  leadTimeText: (d) => `${pluralize('day', d)}`,
};

PriceMatrix.propTypes = {
  lineItem: PropTypes.object.isRequired,
  tableStripe: PropTypes.bool,
  tableSm: PropTypes.bool,
  leadTimeText: PropTypes.func,
  quoteStep: PropTypes.string.isRequired,
};

export default PriceMatrix;
